import styled from 'styled-components';

export const CardPaySystemLogo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 45px;
  }
`;

export const StyledStripeCard = styled.div`
  box-shadow: 0 1px 3px 0 rgb(50 50 93 / 15%), 0 4px 6px 0 rgb(112 157 199 / 15%);
  border-radius: 4px;
  border: none;
  font-size: 0;
  padding: 10px 15px;
`;

export const StyledStripeSubmit = styled.button`
  display: block;
  background: #666ee8;
  color: #fff;
  box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);
  border-radius: 4px;
  border: 0;
  font-weight: 700;
  width: 100%;
  height: 40px;
  outline: none;
  cursor: pointer;
  transition: all 0.15s ease;

  &:focus {
    background: #555abf;
  }

  &:active {
    background: #43458b;
  }

  &[disabled] {
    background: #8287c5;

    cursor: not-allowed;
  }
`;
